import * as React from 'react'
import AppBar from '@mui/material/AppBar'
import {
  MenuList,
  MenuItem,
  ListItemText,
  ListItemIcon,
  Typography,
  IconButton,
  Avatar,
  Tooltip,
  styled,
  CardContent,
  Card,
  Box,
  Tabs,
  Tab,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
} from '@mui/material'
import PersonIcon from '@mui/icons-material/Person'
import MenuOpenIcon from '@mui/icons-material/MenuOpen'
import OPDVisits from './VisitDashboard'
import PatientNavigation from './PatientNavigation'
import { makeStyles } from '../../utils/hooks/makeStyles'
import AddBoxIcon from '@mui/icons-material/AddBox'
// import LmsDashboard from '../lms/components/dashboard/LmsDashboard'
import Registration from './Registration'
import RefreshIcon from '@mui/icons-material/Refresh'
import { getCampPatientsList } from '../../services/CampManagementService'
import { useLocation } from 'react-router-dom'
import Vitals from './Vitals'
import LabList from './lab/LabList'
import { getSelectedCamp } from '../campManagement/campManagementSlice'
import { useSelector } from 'react-redux'
import SelectableSearch from '../../components/SelectableSearch'
import CampDashboard from './dashboard/CampDashboard'
import { useAppDispatch } from '../../app/hooks'
import { setOpdPatientData } from '../opd/OpdPatientSlice'

const SIDEBAR_WIDTH = 350

const useStyles = makeStyles((theme) => ({
  menuBtn: {
    color: '#fff',
  },
  menuItemStyle: {
    textTransform: 'capitalize',
    padding: '4px 0',
    '& .MuiListItemText-primary': {
      fontWeight: 400,
    },
    '&.Mui-selected': {
      backgroundColor: 'transparent',
      '&:hover': {
        backgroundColor: 'transparent',
      },
    },
    '& .MuiListItemText-secondary': {
      fontSize: '0.8rem',
    },
    '&.Mui-selected:hover': {
      backgroundColor: 'rgba(0, 0, 0, 0.04)',
    },
  },
  patientCard: {
    width: '100%',
    borderRadius: '4px',
    margin: '2px 0',
    '&.selected': {
      backgroundColor: 'rgba(25, 118, 210, 0.08)',
      border: '1px solid #1976d2',
    },
    '&:not(.selected)': {
      backgroundColor: 'white',
      border: '1px solid #e0e0e0',
    },
  },
  cardContent: {
    padding: '2px 8px',
    minHeight: '40px',
    display: 'flex',
    alignItems: 'center',
  },
  cardContentWrapper: {
    display: 'flex',
    alignItems: 'center',
    width: '100%',
  },
  patientDetails: {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    marginLeft: '6px',
  },
  detailItemContainer: {
    display: 'flex',
    gap: '8px',
  },
  patientIcon: {
    borderRadius: '3px',
    padding: '1px 4px',
    marginRight: '6px',
    minWidth: '24px',
    textAlign: 'center',
    '&.selected': {
      backgroundColor: '#1976d2',
    },
    '&:not(.selected)': {
      backgroundColor: '#f5f5f5',
    },
  },
  icon: {
    fontSize: '1rem',
    '&.selected': {
      color: '#fff',
    },
    '&:not(.selected)': {
      color: 'rgba(0, 0, 0, 0.54)',
    },
  },
  patientName: {
    fontWeight: 500,
    lineHeight: '1.2',
    margin: '8px 0 1px 0',
    fontSize: '0.8125rem',
    '&.selected': {
      color: '#1976d2',
    },
    '&:not(.selected)': {
      color: 'rgba(0, 0, 0, 0.87)',
    },
  },
  detailsContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: '2px',
    marginTop: '1px',
    '& .detail-row': {
      display: 'flex',
      gap: '12px',
      flexWrap: 'wrap',
    },
    '& .detail-item': {
      display: 'flex',
      alignItems: 'center',
      fontSize: '0.75rem',
    },
  },
  detailText: {
    display: 'flex',
    alignItems: 'center',
    whiteSpace: 'nowrap',
    fontSize: '0.75rem',
    '&.selected': {
      color: 'rgba(25, 118, 210, 0.8)',
    },
    '&:not(.selected)': {
      color: 'rgba(0, 0, 0, 0.6)',
    },
  },
  detailLabel: {
    marginRight: '2px',
    fontWeight: 'bold',
  },
  profileRoot: {
    display: 'flex',
    alignItems: 'center',
    padding: '16px',
    borderRadius: '12px',
    boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
    backgroundColor: '#fff',
    width: 'fit-content',
    minWidth: 300,
    maxWidth: 500,
    border: `1px solid ${theme.palette.divider}`,
    marginBottom: 20,
  },
  avatar: {
    width: 50,
    height: 50,
    marginRight: 16,
    backgroundColor: '#1976d2',
    fontSize: 24,
    fontWeight: 600,
  },
  details: {
    display: 'flex',
    flexDirection: 'column',
  },
  name: {
    fontWeight: 600,
    fontSize: '1rem',
    textTransform: 'capitalize',
  },
  age: {
    fontSize: '0.8rem',
    color: '#555',
  },
  mobile: {
    fontSize: '0.8rem',
    color: '#1976d2',
    marginTop: 4,
  },
  muhId: {
    fontSize: '0.8rem',
    color: '#555',
    fontWeight: 500,
  },
  unpaidLink: {
    textTransform: 'initial',
    background: '#E35335',
    color: 'white',
    padding: '2px 8px',
    fontSize: '10px',
    fontWeight: 600,
    position: 'relative',
    display: 'inline-block',
    clipPath:
      'polygon(0 0, calc(100% - 8px) 0, 100% 50%, calc(100% - 8px) 100%, 0 100%)',
    '&:hover': {
      background: '#E35335',
    },
  },
  paidLink: {
    textTransform: 'initial',
    outline: 'border-box',
    background: 'green',
    color: 'white',
    padding: '0px 2px',
    fontSize: '10px',
    '&:hover': {
      background: 'green',
    },
  },
  sidebar: {
    position: 'fixed',
    left: 0,
    top: 40,
    height: '95vh',
    zIndex: 1200,
    background: '#fff',
    boxShadow: theme.shadows[3],
    minWidth: SIDEBAR_WIDTH,
    maxWidth: SIDEBAR_WIDTH,
    transition: 'transform 0.3s',
  },
  sidebarContent: {
    width: SIDEBAR_WIDTH,
    padding: theme.spacing(1),
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
  },
  searchRow: {
    display: 'flex',
    flexDirection: 'row',
    gap: theme.spacing(1),
    alignItems: 'center',
  },
  sidebarMenu: {
    flex: 1,
    overflow: 'auto',
  },
  sidebarNoPatients: {
    padding: theme.spacing(2),
    textAlign: 'center',
  },
  campNameContainer: {
    display: 'flex',
    justifyContent: 'flex-start',
    padding: '10px 0px',
    maxWidth: '100%',
    overflow: 'hidden',
  },
  campNameText: {
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    maxWidth: '100%',
    color: '#183f7c',
    fontWeight: 600,
    fontSize: '0.875rem',
    textAlign: 'left',
  },

  mainContent: {
    position: 'absolute',
    left: 0,
    top: 0,
    width: '100%',
    height: '100vh',
    transition: 'left 0.3s, width 0.3s',
    backgroundColor: theme.palette.background.paper,
    display: 'flex',
    flexDirection: 'column',
    /* allow children to stretch to full width instead of being centered
       so wide tables or flex children can shrink properly inside this area */
    alignItems: 'stretch',
    overflow: 'auto',
    boxSizing: 'border-box',
    minWidth: 0,
  },
  mainContentShift: {
    left: SIDEBAR_WIDTH,
    width: `calc(100% - ${SIDEBAR_WIDTH}px)`,
    transition: 'left 0.3s, width 0.3s',
    minWidth: 0,
  },
  appBar: {
    position: 'static',
    width: '100%',
    zIndex: 1,
  },
  appBarRow: {
    display: 'flex',
    alignItems: 'center',
    width: '100%',
  },
  appBarLeft: {
    backgroundColor: '#4682b4',
    display: 'flex',
    alignItems: 'center',
    height: '100%',
    borderTopLeftRadius: 4,
    borderBottomLeftRadius: 4,
    paddingRight: theme.spacing(1),
  },
  menuBtnIcon: {
    marginLeft: theme.spacing(1),
    alignSelf: 'center',
    backgroundColor: 'transparent',
    color: '#fff',
  },
  tabsBox: {
    flex: 1,
  },
  tabPanel: {
    height: '100%',
    width: '100%',
    minHeight: 0,
    margin: 5,
  },
  tabPanelBox: {
    padding: theme.spacing(2),
    height: '100%',
    width: '100%',
    boxSizing: 'border-box',
    marginLeft: 'auto',
    marginRight: 'auto',
    /* allow inner content to shrink inside flex containers */
    minWidth: 0,
  },
  registrationPanel: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    minHeight: 'calc(100vh - 120px)',
    width: '100%',
    overflow: 'auto',
  },
  columnPanel: {
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
    width: '100%',
    overflow: 'auto',
    /* allow this column to shrink inside flex parents (prevents child tables from forcing overflow) */
    minWidth: 0,
  },
  labOrderPanel: {
    display: 'flex',
    flexDirection: 'column',
    height: '96%',
    width: '100%',
  },
  labOrderBox: {
    height: '40%',
    overflow: 'auto',
    marginRight: 15,
    marginLeft: 5,
  },
  labInvoicesBox: {
    width: '100%',
    height: '70vh', // Fixed viewport height
    minHeight: '500px', // Minimum height to prevent too much shrinking
    overflow: 'auto', // Allow scrolling if content is larger than container
  },
}))

export const StyledTabs = styled(Tabs)(() => ({
  backgroundColor: '#4682b4',
  '& .MuiButtonBase-root': {
    textTransform: 'capitalize',
  },
  '& .MuiTab-root': {
    fontSize: '13px',
    fontWeight: 500,
  },
  '& .Mui-selected': {
    fontWeight: 600,
    fontSize: '13px',
  },
  '& .MuiTabs-indicator': {
    backgroundColor: '#ffffff',
  },
}))

interface TabPanelProps {
  children?: React.ReactNode
  dir?: string
  index: number
  value: number
  className?: string
}

function TabPanel(props: TabPanelProps) {
  const { children, value, index, className, ...other } = props
  const classes = useStyles()

  return (
    <Box
      role='tabpanel'
      hidden={value !== index}
      id={`full-width-tabpanel-${index}`}
      aria-labelledby={`full-width-tab-${index}`}
      {...other}
      className={className}
    >
      {value === index && <Box className={classes.tabPanelBox}>{children}</Box>}
    </Box>
  )
}

function a11yProps(index: number) {
  return {
    id: `full-width-tab-${index}`,
    'aria-controls': `full-width-tabpanel-${index}`,
  }
}

interface ProfileProps {
  name: string
  age: number
  mobile: string
  muhId?: string
  avatarUrl?: string
}

const Profile: React.FC<ProfileProps> = ({
  name,
  age,
  mobile,
  muhId,
  avatarUrl,
}) => {
  const classes = useStyles()

  return (
    <Box className={classes.profileRoot}>
      <Avatar src={avatarUrl} className={classes.avatar}>
        {!avatarUrl && name ? name?.charAt(0) : '?'}
      </Avatar>
      <Box className={classes.details}>
        <Typography className={classes.name}>{name}</Typography>
        <Box display='flex' gap={2}>
          <Typography className={classes.age}>Age: {age}</Typography>
          {muhId && (
            <Typography className={classes.muhId}>MUH ID: {muhId}</Typography>
          )}
        </Box>
        <Typography className={classes.mobile}>📞 {mobile}</Typography>
      </Box>
    </Box>
  )
}

export default function PatientView() {
  const classes = useStyles()
  const dispatch = useAppDispatch()
  const location = useLocation()
  const selectedCamp = useSelector(getSelectedCamp)
  const [value, setValue] = React.useState(0)
  const [openPatientMenu, setOpenPatientMenu] = React.useState(true)
  const [selectedPatient, setSelectedPatient] = React.useState<any>({})
  const selectedPatientRef = React.useRef<any>({})

  const [labOrderDirty, setLabOrderDirty] = React.useState(false)
  const [showDirtyDialog, setShowDirtyDialog] = React.useState(false)
  const pendingActionRef = React.useRef<(() => void) | null>(null)

  const guardedAction = (action: () => void) => {
    if (labOrderDirty) {
      pendingActionRef.current = action
      setShowDirtyDialog(true)
    } else {
      action()
    }
  }

  const handleConfirmDirtyLeave = () => {
    setShowDirtyDialog(false)
    setLabOrderDirty(false)
    pendingActionRef.current?.()
    pendingActionRef.current = null
  }

  const handleCancelDirtyLeave = () => {
    setShowDirtyDialog(false)
    pendingActionRef.current = null
  }

  // Define all possible tabs with their visibility conditions
  const { visibleTabs } = React.useMemo(() => {
    const tabs = [
      { id: 'registration', label: 'Registration' },
      {
        id: 'basicHealth',
        label: 'Basic Health Info',
        hidden: selectedPatient?.checkIn === true,
      },
      { id: 'visit', label: 'Visit' },
      { id: 'lab', label: 'Lab order' },
      { id: 'dashboard', label: 'Dashboard' },
    ]

    const visibleTabs = tabs?.filter((tab) => !tab.hidden)

    return { tabs, visibleTabs }
  }, [selectedPatient?.checkIn])

  const getTabIndex = (tabId: string) => {
    return visibleTabs?.findIndex((tab) => tab?.id === tabId)
  }
  const [filteredPatients, setFilteredPatients] = React.useState<any[]>([])
  const campDetails = location.state?.camp ?? (selectedCamp || null)
  // const [latestVisitId, setLatestVisitId] = React.useState<string>('')

  const [page, setPage] = React.useState<number>(0)
  const [size, setSize] = React.useState<number>(20)
  const [totalElements, setTotalElements] = React.useState<number>(0)
  const [searchTerm, setSearchTerm] = React.useState<{
    query: string
    param: string
  }>({
    query: '',
    param: '',
  })

  // const fetchLatestVisit = React.useCallback(async () => {
  //   if (!selectedPatient?.patientUhid || !campDetails?.campId) {
  //     setLatestVisitId('')
  //     return
  //   }

  //   try {
  //     const response = await getAllCampAppointments(
  //       campDetails?.campId,
  //       selectedPatient?.patientUhid
  //     )

  //     const visits = response?.data || []
  //     const latestVisit = visits[0]

  //     if (latestVisit?.visitId) {
  //       setLatestVisitId(latestVisit?.visitId)
  //     } else {
  //       setLatestVisitId(selectedPatient?.patientFhirId || '')
  //     }
  //   } catch (error) {
  //     setLatestVisitId(selectedPatient?.patientFhirId || '')
  //   }
  // }, [
  //   selectedPatient?.patientUhid,
  //   selectedPatient?.patientFhirId,
  //   campDetails?.campId,
  // ])

  // React.useEffect(() => {
  //   // Only fetch latest visit if the 'Visit' tab is active
  //   const visitTabIndex = getTabIndex('visit')
  //   if (value === visitTabIndex) {
  //     fetchLatestVisit()
  //   }
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, [fetchLatestVisit])

  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    // setValue(newValue)
    guardedAction(() => setValue(newValue))
  }

  // Store the previous visible tabs to detect actual changes
  const prevVisibleTabsRef = React.useRef(visibleTabs)

  React.useEffect(() => {
    const prevTabs = prevVisibleTabsRef.current
    const currentTabId = prevTabs[value]?.id

    // Check if the tabs actually changed (not just a new array reference)
    const tabsChanged =
      prevTabs.length !== visibleTabs.length ||
      prevTabs.some((tab, idx) => tab.id !== visibleTabs[idx]?.id)

    if (tabsChanged && currentTabId) {
      // Try to find the current tab in the new list
      const newIndex = visibleTabs.findIndex((tab) => tab.id === currentTabId)

      if (newIndex !== -1 && newIndex !== value) {
        // Tab moved to a different position
        setValue(newIndex)
      } else if (newIndex === -1) {
        // Tab no longer exists, go to first tab
        setValue(0)
      }
    } else if (value >= visibleTabs.length) {
      // Current index out of bounds
      setValue(0)
    }

    prevVisibleTabsRef.current = visibleTabs
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [visibleTabs])

  React.useEffect(() => {
    const t = window.setTimeout(() => {
      try {
        window.dispatchEvent(new Event('resize'))
      } catch (e) {
        // ignore
      }
    }, 350)
    return () => clearTimeout(t)
  }, [openPatientMenu])

  const handleCreate = () => {
    // handlePatientSelect({ fhirId: '', muhId: '' })
    // setValue(0)
    guardedAction(() => {
      handlePatientSelect({ fhirId: '', muhId: '' })
      setValue(0)
    })
  }

  const getPatientList = React.useCallback(async () => {
    const resOfPatientList = await getCampPatientsList(
      campDetails?.campId,
      page,
      size,
      searchTerm
    )
    setFilteredPatients(resOfPatientList?.data?.records || [])
    setTotalElements(resOfPatientList?.data?.totalRecords || 0)

    // Only update selected patient if we have a UHID to match
    if (selectedPatientRef.current?.patientUhid) {
      const updatedPatient = resOfPatientList?.data?.records?.find(
        (patient: any) =>
          patient?.patientUhid === selectedPatientRef.current?.patientUhid
      )
      // Only update if we found a match, otherwise keep the current selection
      if (updatedPatient) {
        handlePatientSelect(updatedPatient)
      }
    } else {
      handlePatientSelect({ fhirId: '', muhId: '' })
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [campDetails?.campId, page, size, searchTerm])

  const handlePatientSelect = (patient: any) => {
    setSelectedPatient(patient)
    selectedPatientRef.current = patient
    // Update Redux store so OpdDevices and other components can access the selected patient
    dispatch(setOpdPatientData(patient))
  }

  const handleSearch = (query: string, param: string) => {
    setSearchTerm({ query: param, param: query })
    setPage(0)
    setSize(20)
  }

  React.useEffect(() => {
    getPatientList()
  }, [getPatientList])

  return (
    <Box width='100%' height='100vh' position='relative' overflow='auto'>
      {/* Sidebar: Docked, not overlaying header */}
      <Dialog
        open={showDirtyDialog}
        onClose={handleCancelDirtyLeave}
        maxWidth='xs'
        fullWidth
      >
        <DialogTitle>Unsaved Barcodes</DialogTitle>
        <DialogContent>
          <Typography variant='body2'>
            You have scanned barcodes that haven&apos;t been submitted yet. If
            you continue, your scanned barcodes will be lost.
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button variant='contained' onClick={handleCancelDirtyLeave}>
            Cancel
          </Button>
          <Button
            variant='contained'
            color='error'
            onClick={handleConfirmDirtyLeave}
          >
            OK, Continue
          </Button>
        </DialogActions>
      </Dialog>
      {openPatientMenu && (
        <Box className={classes.sidebar}>
          <Box className={classes.sidebarContent}>
            {/* Camp Name Display */}
            {campDetails?.name && (
              <Box className={classes.campNameContainer}>
                <Typography
                  variant='subtitle2'
                  className={classes.campNameText}
                  title={campDetails.name}
                >
                  {campDetails.name}
                </Typography>
              </Box>
            )}

            {/* Top: Search */}
            <Box className={classes.searchRow}>
              {/* <Search
                items={['employeeId', 'mobile', 'patientUhid']}
                onSearch={handleSearch}
              /> */}
              <SelectableSearch
                items={['patientUhid', 'mobile', 'employeeId']}
                onSearch={handleSearch}
              />
              <Tooltip title='Refresh Data'>
                <IconButton onClick={getPatientList}>
                  <RefreshIcon />
                </IconButton>
              </Tooltip>
            </Box>
            {/* Middle: MenuList (scrollable) */}
            <Box className={classes.sidebarMenu}>
              <MenuList>
                <MenuItem
                  onClick={handleCreate}
                  selected={selectedPatient?.fhirId === ''}
                  className={classes?.menuItemStyle}
                >
                  <ListItemIcon>
                    <AddBoxIcon
                      fontSize='small'
                      htmlColor={
                        selectedPatient?.fhirId === '' ? '#4682b4' : 'inherit'
                      }
                    />
                  </ListItemIcon>
                  <ListItemText primary={'Create New'} />
                </MenuItem>
                {filteredPatients?.length > 0 ? (
                  filteredPatients?.map((patient: any) => (
                    <MenuItem
                      key={patient?.id}
                      // onClick={() => handlePatientSelect(patient)}
                      onClick={() =>
                        guardedAction(() => handlePatientSelect(patient))
                      }
                      selected={
                        selectedPatient?.patientFhirId ===
                        patient?.patientFhirId
                      }
                      className={classes.menuItemStyle}
                    >
                      <Card
                        elevation={1}
                        className={`${classes.patientCard} ${
                          selectedPatient?.patientFhirId ===
                          patient?.patientFhirId
                            ? 'selected'
                            : ''
                        }`}
                      >
                        <CardContent className={classes.cardContent}>
                          <Box className={classes.cardContentWrapper}>
                            <Box
                              className={`${classes.patientIcon} ${
                                selectedPatient?.patientFhirId ===
                                patient?.patientFhirId
                                  ? 'selected'
                                  : ''
                              }`}
                            >
                              <PersonIcon className={classes.icon} />
                            </Box>
                            <Box className={classes.patientDetails}>
                              <Typography
                                variant='subtitle2'
                                className={`${classes.patientName} ${
                                  selectedPatient?.patientFhirId ===
                                  patient?.patientFhirId
                                    ? 'selected'
                                    : ''
                                }`}
                              >
                                {/* {patient?.firstName} {patient?.lastName} */}
                                {patient?.fullName ??
                                  `${patient?.firstName} ${patient?.lastName}`}
                              </Typography>
                              <Box className={classes.detailsContainer}>
                                <div className={classes.detailItemContainer}>
                                  {patient?.patientUhid && (
                                    <div className='detail-item'>
                                      <Typography
                                        variant='caption'
                                        className={`${classes.detailText} ${
                                          selectedPatient?.patientFhirId ===
                                          patient?.patientFhirId
                                            ? 'selected'
                                            : ''
                                        }`}
                                      >
                                        <span className={classes.detailLabel}>
                                          UHID:&nbsp;
                                        </span>
                                        {patient?.patientUhid}
                                      </Typography>
                                    </div>
                                  )}
                                  <div className={classes.detailItemContainer}>
                                    <Typography
                                      variant='caption'
                                      className={`${classes.detailText} ${
                                        selectedPatient?.patientFhirId ===
                                        patient?.patientFhirId
                                          ? 'selected'
                                          : ''
                                      }`}
                                    >
                                      <span className={classes.detailLabel}>
                                        Age:&nbsp;
                                      </span>
                                      {patient?.age || 'N/A'}
                                    </Typography>
                                    {(patient?.visitsCreated !== undefined ||
                                      patient?.visitsCompleted !==
                                        undefined) && (
                                      <Typography
                                        variant='caption'
                                        className={`${classes.detailText} ${
                                          selectedPatient?.patientFhirId ===
                                          patient?.patientFhirId
                                            ? 'selected'
                                            : ''
                                        }`}
                                      >
                                        <span className={classes.detailLabel}>
                                          | Visits:&nbsp;
                                        </span>
                                        {`${patient?.visitsCompleted || 0}/${
                                          patient?.visitsCreated || 0
                                        }`}
                                      </Typography>
                                    )}
                                  </div>
                                </div>
                                <div className={classes.detailItemContainer}>
                                  {patient?.phoneNumber && (
                                    <Typography
                                      variant='caption'
                                      className={`${classes.detailText} ${
                                        selectedPatient?.patientFhirId ===
                                        patient?.patientFhirId
                                          ? 'selected'
                                          : ''
                                      }`}
                                    >
                                      <span className={classes.detailLabel}>
                                        Ph:&nbsp;
                                      </span>
                                      {patient?.phoneNumber}
                                    </Typography>
                                  )}
                                  {patient?.gender && (
                                    <Typography
                                      variant='caption'
                                      className={`${classes.detailText} ${
                                        selectedPatient?.patientFhirId ===
                                        patient?.patientFhirId
                                          ? 'selected'
                                          : ''
                                      }`}
                                    >
                                      <span className={classes.detailLabel}>
                                        |&nbsp;Gender:&nbsp;
                                      </span>
                                      {patient?.gender}
                                    </Typography>
                                  )}
                                </div>
                                {patient?.employeeId && (
                                  <Typography
                                    variant='caption'
                                    className={`${classes.detailText} ${
                                      selectedPatient?.patientFhirId ===
                                      patient?.patientFhirId
                                        ? 'selected'
                                        : ''
                                    }`}
                                    ml={-0.5}
                                  >
                                    <span className={classes.detailLabel}>
                                      &nbsp;Employee ID:&nbsp;
                                    </span>
                                    {patient?.employeeId}
                                  </Typography>
                                )}
                              </Box>
                            </Box>
                          </Box>
                        </CardContent>
                      </Card>
                    </MenuItem>
                  ))
                ) : (
                  <Typography
                    variant='body2'
                    color='text.secondary'
                    className={classes.sidebarNoPatients}
                  >
                    {searchTerm?.query
                      ? 'No matching patients found'
                      : 'No patients found'}
                  </Typography>
                )}
              </MenuList>
            </Box>
            <PatientNavigation
              page={page}
              setPage={setPage}
              size={size}
              setSize={setSize}
              count={totalElements}
              pageSizeOptions={[10, 20, 50, 100]}
            />
          </Box>
        </Box>
      )}

      {/* Main Content */}
      <Box
        className={
          openPatientMenu
            ? `${classes.mainContent} ${classes.mainContentShift}`
            : classes.mainContent
        }
      >
        <AppBar className={classes.appBar}>
          <Box className={classes.appBarRow}>
            <Box className={classes.appBarLeft}>
              <IconButton
                onClick={() => setOpenPatientMenu(!openPatientMenu)}
                color='inherit'
                className={classes.menuBtnIcon}
              >
                <MenuOpenIcon />
              </IconButton>
            </Box>
            <Box className={classes.tabsBox}>
              <StyledTabs
                value={value}
                onChange={handleChange}
                textColor='inherit'
                scrollButtons='auto'
                variant='fullWidth'
                centered
              >
                {visibleTabs?.map((tab, index) => (
                  <Tab key={tab.id} label={tab.label} {...a11yProps(index)} />
                ))}
              </StyledTabs>
            </Box>
          </Box>
        </AppBar>
        <TabPanel
          value={value}
          index={getTabIndex('dashboard')}
          className={classes.tabPanel}
        >
          <Box>
            <CampDashboard camp={campDetails || selectedCamp} />
          </Box>
        </TabPanel>
        <TabPanel
          value={value}
          index={getTabIndex('registration')}
          className={classes.tabPanel}
        >
          <Box className={classes.registrationPanel}>
            <Registration
              selectedCamp={campDetails || selectedCamp}
              patient={selectedPatient}
              onSuccess={getPatientList}
            />
          </Box>
        </TabPanel>
        <TabPanel
          value={value}
          index={getTabIndex('basicHealth')}
          className={classes.tabPanel}
        >
          <Box className={classes.columnPanel}>
            {selectedPatient?.patientFhirId && (
              <Profile
                name={
                  selectedPatient?.firstName + ' ' + selectedPatient?.lastName
                }
                age={selectedPatient?.age}
                mobile={selectedPatient?.phoneNumber}
                muhId={selectedPatient?.patientUhid}
                avatarUrl={selectedPatient?.avatarUrl}
              />
            )}
            {/* <Appointment
              fhirId={selectedPatient?.patientFhirId}
              muhId={selectedPatient?.patientUhid}
            /> */}

            <Vitals
              campId={campDetails?.campId}
              patientUhid={selectedPatient?.patientUhid}
              getPatientList={getPatientList}
            />
          </Box>
        </TabPanel>
        <TabPanel
          value={value}
          index={getTabIndex('visit')}
          className={classes.tabPanel}
        >
          <Box className={classes.columnPanel}>
            {selectedPatient?.patientFhirId && (
              <Profile
                name={
                  selectedPatient?.firstName + ' ' + selectedPatient?.lastName
                }
                age={selectedPatient?.age}
                mobile={selectedPatient?.phoneNumber}
                muhId={selectedPatient?.patientUhid}
                avatarUrl={selectedPatient?.avatarUrl}
              />
            )}
            <OPDVisits
              id={selectedPatient?.patientFhirId}
              campDetails={campDetails || selectedCamp}
              patientDetails={selectedPatient}
            />
          </Box>
        </TabPanel>
        <TabPanel
          value={value}
          index={getTabIndex('lab')}
          className={classes.tabPanel}
        >
          <Box className={classes.columnPanel}>
            {selectedPatient?.patientFhirId && (
              <Profile
                name={
                  selectedPatient?.firstName + ' ' + selectedPatient?.lastName
                }
                age={selectedPatient?.age}
                mobile={selectedPatient?.phoneNumber}
                muhId={selectedPatient?.patientUhid}
                avatarUrl={selectedPatient?.avatarUrl}
              />
            )}
            {/* <LabList patientData={selectedPatient} />
             */}
            <LabList
              patientData={selectedPatient}
              onDirtyChange={setLabOrderDirty}
            />
          </Box>
        </TabPanel>
      </Box>
    </Box>
  )
}
